import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Plugin } from 'src/app/models/plugin';
import { BuilderRequestModel } from 'src/app/models/builder/builder-request.model';
import { StatusRequestModel } from 'src/app/models/status/status-request.model';
import { CloudDocumentService } from './cloud-document.service';
import { ExternalContentProviderSource } from 'src/app/constants/ExternalContentProviders.enum';

export const CloudExportDocumentModalOptions: NgbModalOptions = {
  centered: true,
  size: 'xl',
  windowClass: 'modal-xxl'
};

@Component({
    templateUrl: './cloud-document.modal.html',
    styleUrls: ['./cloud-document.modal.css'],
    providers: [CloudDocumentService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudDocumentExportModal implements OnInit {
  @Input() modalTitleTranslationKey = 'CloudLocations.ExportTitle';
  @Input() enabledPlugins: Plugin[] = [];
  @Input() fileName: string = '';
  @Input() request: BuilderRequestModel | StatusRequestModel | null = null;
  @Input() isForAutoExport: boolean = false;
  @Input() requestId: string = '';

  @Output() close = new EventEmitter<any>();

  constructor(private cloudDocumentService: CloudDocumentService) { }

  ngOnInit(): void {
    this.cloudDocumentService.init({
      isExportMode: true,
      isForAutoExport: this.isForAutoExport,
      requestId: this.requestId,
      enabledPlugins: this.enabledPlugins ?? [],
      fileName: this.fileName,
      request: this.request
    });
  }

  get hasSelectedProvider() { return this.cloudDocumentService.hasSelectedProvider; }
  get detailsCollapsed() { return this.cloudDocumentService.detailsCollapsed; }
  get searchTerm() { return this.cloudDocumentService.searchTerm; }
  set searchTerm(v: string) { this.cloudDocumentService.searchTerm = v; }
  get isHyarchisSource() { return this.cloudDocumentService.isHyarchisSource; }

  closeDialog() { this.cloudDocumentService.closeDialog(); }
  onSearchChange(value: string) { this.cloudDocumentService.onSearchChange(value); }
  toggleCloudDetails() { this.cloudDocumentService.toggleCloudDetails(); }
}
